export default __webpack_public_path__ + "87928b6ee38507f8720090454de787c6.png";